import Marquee from "react-fast-marquee";

const symbols = ["Story", "Cinema", "Desert", "Motion", "Light", "Craft"];

export const EditorialMarquee = () => (
  <section
    className="border-y border-border bg-surface py-8"
    data-testid="editorial-marquee"
  >
    <Marquee speed={40} gradient={false} className="marquee-track">
      {symbols.concat(symbols).map((word, i) => (
        <span key={i} className="mx-10 inline-flex items-center gap-10">
          <span className="font-display text-5xl italic text-sand-100 md:text-7xl">
            {word}
          </span>
          <span className="text-sand-700 text-4xl md:text-6xl">&#9670;</span>
        </span>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
